import React, { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X, ZoomIn } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ImageLightbox = ({ src, alt, className, thumbnailClassName }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!src) return null;

  return (
    <>
      <div 
        className={`relative cursor-pointer group ${className || ''}`}
        onClick={() => setIsOpen(true)}
      >
        <img 
          src={src} 
          alt={alt || 'Image'} 
          className={thumbnailClassName || 'w-full h-full object-cover'}
        />
        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <ZoomIn className="h-6 w-6 text-white" />
        </div>
      </div>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="bg-wt-paper border-wt-border max-w-4xl p-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsOpen(false)}
            className="absolute top-2 right-2 z-10 text-wt-text-muted hover:text-wt-text-primary bg-wt-bg/80 rounded-full h-8 w-8 p-0"
          >
            <X className="h-5 w-5" />
          </Button>
          <img 
            src={src} 
            alt={alt || 'Image'} 
            className="max-w-full max-h-[80vh] object-contain mx-auto rounded-lg"
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageLightbox;
